import { z } from "zod";

import { emailSchema } from "./auth";

/**
 * Enterprise organizasyon türleri (CLOS-71 `[023]`).
 *
 * `enterprise_company` şirket (CLOS-71 `[023]`), `enterprise_law_firm` hukuk bürosu
 * (CLOS-72 `[024]`).
 *
 * İkisi ALTERNATİF DEĞİL, ayrı ve değişmez türler. Hukuk bürosu müvekkil hizmet
 * ilişkilerinin bağlamıdır; şirket değildir. Tür sonradan çevrilemiyor — veritabanında
 * kolon yazma yetkisi geri alınmış durumda.
 */
export const ENTERPRISE_TENANT_TYPES = ["enterprise_company", "enterprise_law_firm"] as const;
export type EnterpriseTenantType = (typeof ENTERPRISE_TENANT_TYPES)[number];

/**
 * Bütün çalışma alanı türleri — kişisel alan dahil (CLOS-70 `[022]`).
 *
 * `ENTERPRISE_TENANT_TYPES` "kullanıcı hangi türde organizasyon açabilir" sorusunun cevabı;
 * bu liste ise "sistemde hangi çalışma alanı türleri var" sorusunun. Kişisel alan
 * açılmıyor, hesapla birlikte DOĞUYOR — bu yüzden oluşturma şemasında yeri yok.
 */
export const TENANT_TYPES = ["individual", ...ENTERPRISE_TENANT_TYPES] as const;
export type TenantType = (typeof TENANT_TYPES)[number];

export const createTenantSchema = z.object({
  name: z
    .string({ error: "Firma adı zorunludur" })
    .trim()
    .min(2, "Firma adı en az 2 karakter olmalıdır")
    .max(200, "Firma adı en fazla 200 karakter olabilir"),

  /**
   * Tür AÇIKÇA gönderilir; varsayılanı YOK.
   *
   * Varsayılan koysaydık kullanıcı yanlış türde bir organizasyon açabilir ve tür
   * değiştirilemez olduğu için (DB'de kolon yetkisi geri alınmış) geri dönemezdi.
   * Kritik ve geri alınamaz bir seçimde sessiz varsayılan, kullanıcıyı tuzağa düşürür.
   */
  type: z.enum(ENTERPRISE_TENANT_TYPES, { error: "Organizasyon türü seçilmelidir" }),
});
export type CreateTenantInput = z.infer<typeof createTenantSchema>;

/**
 * Organizasyon daveti (CLOS-73 `[034]`).
 *
 * `[034]` öncesinde bu şema `role: "admin" | "member"` alıyordu ve uç mevcut bir
 * kullanıcıyı anında üye yapıyordu. Gerçek davet akışında rol, kanonik rol ÖRNEĞİNİN
 * kimliğiyle seçiliyor: metinsel kademe hem özel rolleri ifade edemiyordu hem de
 * `[025]`'in kanonik model kararıyla çelişiyordu.
 */
export const inviteMemberSchema = z.object({
  // `emailSchema`: davet e-postası da kayıt/giriş ile AYNI biçimde normalize edilir
  // (trim + ASCII lowercase). Ham `z.email()` bıraksaydık `Ali@X.com` ile davet edilip
  // `ali@x.com` ile kabul eden akış arasında büyük/küçük harf uyuşmazlığı doğardı.
  email: emailSchema,
  roleId: z.uuid("Geçerli bir rol seçilmelidir"),
});
export type InviteMemberInput = z.infer<typeof inviteMemberSchema>;
